import React, { useEffect, useState } from "react";
import Header from "./Header";
import { useSelector } from "react-redux";
import axios from "axios";
import { Box, Skeleton, Typography } from "@mui/material";
import surveyImage from "../assets/survey image.png";

const MySurveys = () => {
  const [mySurvey, setMySurvey] = useState([]);
  const user = useSelector((state) => state.user.user);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchActiveSurveys = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/users/get-surveys-taken?username=${user.username}`,
          {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
            },
          }
        );
        const sortedSurveys = res.data.sort(
          (a, b) => new Date(b.updatedDate) - new Date(a.updatedDate)
        );
        setIsLoading(false);
        setMySurvey(sortedSurveys);
        console.log(res.data);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    fetchActiveSurveys();
  }, [user]);

  return (
    <Box className="parent-div">
      <Header heading={"Survey Taken"} />
      <Box
        sx={{ display: "flex", flexDirection: "column", flex: 1 }}
        className="main-container"
      >
        {isLoading ? (
          <Box>
            <Skeleton
              variant="rounded"
              width={"100%"}
              height={100}
              sx={{ my: 1 }}
            />
            <Skeleton
              variant="rounded"
              width={"100%"}
              height={100}
              sx={{ my: 1 }}
            />
            <Skeleton
              variant="rounded"
              width={"100%"}
              height={100}
              sx={{ my: 1 }}
            />
            <Skeleton
              variant="rounded"
              width={"100%"}
              height={100}
              sx={{ my: 1 }}
            />
            <Skeleton
              variant="rounded"
              width={"100%"}
              height={100}
              sx={{ my: 1 }}
            />
          </Box>
        ) : mySurvey.length > 0 ? (
          mySurvey.map((survey, i) => (
            <Box
              key={i}
              className="box-option"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#64748B",
                padding: "20px",
              }}
              my={1}
            >
              <Box sx={{ color: "#BEA800" }}>
                <img src={surveyImage} alt="" width={40} />
              </Box>
              <Box pl={2}>
                <Typography sx={{ textAlign: "left" }}>
                  {survey.surveyName}
                </Typography>
                <Box>
                  <Typography sx={{ textAlign: "left", fontSize: "14px" }}>
                    {new Date(survey.createdDate).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </Typography>
                  <Typography
                    sx={{
                      textAlign: "left",
                      fontSize: "14px",
                      width: "150px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {survey.uploadLink}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))
        ) : (
          <Box sx={{ textAlign: "center", mt: 5 }}>No Surveys Taken Yet</Box>
        )}
      </Box>
    </Box>
  );
};

export default MySurveys;
